import { Text, type TextProps } from "@mantine/core";

type ProperNameProps = {
    name?: string;
} & Omit<TextProps, "children">;

export function ProperName({ name, ...otherProps }: ProperNameProps) {
    const formattedName = name?.toLowerCase();

    return (
        <Text span tt="capitalize" {...otherProps}>
            {formattedName}
        </Text>
    );
}
